import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Image from '@base/Image';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import useDarkModeStatus from '@stores/useDarkModeStatus';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_14B};
  }
`;
const Title = styled(H3)`
  font-weight: ${Fonts.HEAVY};
`;

const ListWrapper = styled.div`
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_6B};
  margin-top: ${Spacings.SPACING_6B};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
    padding: ${Spacings.SPACING_4B};
  }
`;

const RecommendationList = styled.div`
  > div:not(:last-child) {
    margin-bottom: ${Spacings.SPACING_4B};
    ${mediaQuery.uptoMobile} {
      margin-bottom: ${Spacings.SPACING_3B};
    }
  }
`;

const RecommendationWrapper = styled.div`
  display: flex;
`;

const ImageWrapper = styled.div``;

const RecommendationImageWrapper = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const Recommendation = styled(P1)`
  margin-left: ${Spacings.SPACING_3B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
  }
`;

const WhoIsThisCourseFor = ({ recommendationInfo }) => {
  //  Dark mode will be derived by zustand soon.
  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);

  if (!recommendationInfo) return null;

  return (
    <Wrapper>
      {recommendationInfo?.header && <Title>{recommendationInfo.header}</Title>}
      <ListWrapper>
        <RecommendationList>
          {recommendationInfo?.data?.map((item) => {
            const icon = isDarkModeOn ? item?.darkmode_icon : item?.icon;
            return (
              <RecommendationWrapper key={item?.feature}>
                <ImageWrapper>
                  {icon && (
                    <Image src={icon} width={20} height={20} alt="icon" />
                  )}
                </ImageWrapper>
                {item?.text && <Recommendation>{item.text}</Recommendation>}
              </RecommendationWrapper>
            );
          })}
        </RecommendationList>
        {recommendationInfo?.image_url && (
          <RecommendationImageWrapper>
            <Image
              src={recommendationInfo.image_url}
              width={128}
              height={128}
              alt="icon"
            />
          </RecommendationImageWrapper>
        )}
      </ListWrapper>
    </Wrapper>
  );
};
export default WhoIsThisCourseFor;
